import {ConnectedReservationDates} from 'containers/ConnectedReservationDates/ConnectedReservationDates';

export default ConnectedReservationDates;
